export enum Platform {
  Unknown = 0,
  Web = 1,
  Android = 2,
  IOS = 3,
  UnknownMobilePlatform = 99,
  ApiServer = 200,
}
